export default __webpack_public_path__ + "static/media/logo-rocketleague-square.f21070cf.jpg";